import { Dispatch, SetStateAction } from 'react'

import styles from './NumParksPicker.module.scss'

type NumParksPickerProps = {
  numParks: number,
  setNumParks: Dispatch<SetStateAction<number>>
}

export function NumParksPicker({ numParks, setNumParks }: NumParksPickerProps) {

  return (
    <div className={ styles.numParks }>
      <h3 className={ styles.heading }>Number of Parks?</h3>

      <div className={ styles.numbers }>
        <a className={ numParks === 1 ? styles.selected : ''} onClick={ () => setNumParks(1) }>1</a>
        <a className={ numParks === 2 ? styles.selected : ''} onClick={ () => setNumParks(2) }>2</a>
        <a className={ numParks === 3 ? styles.selected : ''} onClick={ () => setNumParks(3) }>3</a>
      </div>
    </div>
  )
}

